// External libraries
import { useState, useEffect } from "react";

import CustomAccordion from "@/src/lib/ui/customAccordion";

const FaqList = ({ faqData }) => {
    const [openAccordion, setOpenAccordion] = useState(null);

    const handleToggle = (itemName) => {
        setOpenAccordion(openAccordion === itemName ? null : itemName);
    };

    return (
        <section className="w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
            <h2 className="px-5 pt-5 pb-2 md:px-7 md:pt-7 text-lg md:text-xl font-semibold tracking-tight text-slate-900">
                Frequently Asked Questions
            </h2>
            <div className="flex w-full flex-col px-2 pb-2 md:px-4 md:pb-4">
                {faqData?.map((item, index) => {
                    const isOpen = openAccordion === item.faqQuestion;

                    return (
                        <CustomAccordion
                            key={item.faqQuestion || index}
                            title={item.faqQuestion}
                            defaultExpanded={false}
                            buttonClassName={`rounded-lg py-4 text-sm md:text-base font-semibold text-slate-900 hover:bg-slate-50! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/30 ${
                                isOpen ? "bg-slate-50!" : "bg-transparent!"
                            }`}
                            className="rounded-none! border-slate-100! last:border-b-0"
                            iconClassName="w-5 h-5 shrink-0"
                            open={isOpen}
                            onClick={() => handleToggle(item.faqQuestion)}
                        >
                            <div
                                className="prose prose-sm md:prose max-w-none px-2 text-sm md:text-base text-slate-600 prose-p:text-slate-600 prose-red custom-faq-answer"
                                dangerouslySetInnerHTML={{
                                    __html: item.faqAnswer,
                                }}
                            />
                        </CustomAccordion>
                    );
                })}
            </div>
        </section>
    );
};

export default FaqList;
